import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import ExampleSlider from 'react-slick';
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { prevArrow, nextArrow } from '../Arrows';
import munozImage from './assets/munoz.png';
import atteberyImage from './assets/attebery.png';
import broichImage from './assets/broich.png';
import wallaceImage from './assets/wallace.png';
import berceaImage from './assets/bercea.png';
import cortesImage from './assets/cortes.png';
import andrew1 from './assets/andrew_1.png';
import preston1 from './assets/preston_1.png';
import simon1 from './assets/simon_1.jpg';
import ben1 from './assets/ben_1.png';
import chad1 from './assets/chad_1.png';
import simon2 from './assets/simon_2.png';
import dennis1 from './assets/dennis_1.jpg';
import simon3 from './assets/simon_3.png';
import styles from './styles.scss';


const images = [
  {
    artist: {
      name: 'Andrew Munoz',
      experience: 'experience + visual designer',
      profileImage: munozImage
    },
    image: andrew1
  },
  {
    artist: {
      name: 'Preston Attebery',
      experience: 'branding + visual designer',
      profileImage: atteberyImage
    },
    image: preston1
  },
  {
    artist: {
      name: 'Simon Broich',
      experience: 'experience + visual designer',
      profileImage: broichImage
    },
    image: simon1
  },
  {
    artist: {
      name: 'Ben Wallace',
      experience: 'branding + visual designer',
      profileImage: wallaceImage
    },
    image: ben1
  },
  {
    artist: {
      name: 'Chad Bercea',
      experience: 'animation + visual designer',
      profileImage: berceaImage
    },
    image: chad1
  },
  {
    artist: {
      name: 'Simon Broich',
      experience: 'experience + visual designer',
      profileImage: broichImage
    },
    image: simon2
  },
  {
    artist: {
      name: 'Dennis Corte\'s',
      experience: 'branding + visual designer',
      profileImage: cortesImage
    },
    image: dennis1
  },
  {
    artist: {
      name: 'Simon Broich',
      experience: 'experience + visual designer',
      profileImage: broichImage
    },
    image: simon3
  }
];

const sliderSettings = {
  autoplay: true,
  autoplaySpeed: 7000,
  slidesToScroll: 1,
  infinite: true,
  dots: true,
  arrows: true,
  nextArrow: nextArrow(),
  prevArrow: prevArrow(),
  lazyLoad: true,
  responsive: [
    {
      breakpoint: 650,
      settings: {
        dots: false
      }
    }
  ]
}

class ExampleCarousel extends Component {
  constructor(props) {
    super(props)
    this.next = this.next.bind(this)
  }

  next() {
    this.refs.slider.slickNext()
  }

  render() {
    const clickAction = this.props.link ? this.goToTalent : this.next;

    const slides = images.map((slide, index) => {
      return (
        <div key={index}>
          <div className={styles.carouselImageContainer} >
            <img onClick={clickAction} src={slide.image} className={styles.exampleCarouselImage} alt="cell-phones"/>
          </div>
          <div className={styles.carouselDetails}>
            <div className={styles.artistDetails}>
              <img src={slide.artist.profileImage} className={styles.artistImage} alt="munoz" />
              <span className={`${styles.artistName} bold`}>{slide.artist.name}</span>
              <span className={styles.artistDescription}>{slide.artist.experience}</span>
            </div>
          </div>
        </div>
      );
    })
    return (
      <div className={styles.exampleSlider}>
        <ExampleSlider {...sliderSettings} ref="slider">
          {slides}
        </ExampleSlider>
      </div>
    );
  }

  goToTalent = () => {
    browserHistory.push(this.props.link);
  }
}

export default ExampleCarousel;



// WEBPACK FOOTER //
// ./src/components/ExampleCarousel/index.js